import React from 'react';
import styles from './FooterBrand.module.css';
import Logo from '../../common/Logo/Logo';

/**
 * @component FooterBrand
 * @description Footer 좌측 브랜드 영역
 */
function FooterBrand({ tagline }) {
  return (
    <div className={styles.footerBrand}>
      <Logo size="medium" />
      <p className={styles.tagline}>{tagline}</p>
    </div>
  );
}

export default FooterBrand;
